import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Modal } from '../modal';
import { filter, finalize, first, Subscription, take } from 'rxjs';
import { ModalHeaderComponent } from '../components/modal-header/modal-header.component';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LocalizedDatePipe } from '../../pipes/localized-date.pipe';
import { LocationNamePipe } from '../../pipes/location-name.pipe';
import { SessionFormat } from '../../enums/session-group/session-formats.enum';
import { SessionAttendanceComponent } from '../../components/session-attendance/session-attendance.component';
import { ModalService } from '../../services/modal.service';
import { FindCustomerModalComponent } from '../find-customer-modal/find-customer-modal.component';
import { LecturerCustomerCardModalComponent, LecturerCustomerCardTab } from 'src/app/pages/admin/org-admin/components/modals/lecturer-customer-card-modal/lecturer-customer-card-modal.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IModalFooterMenuItem, ModalFooterMenuComponent } from '../../components/modal-footer-menu/modal-footer-menu.component';
import { ShopItemsService } from '../../services/entities/shop-items/shop-items.service';
import { IShopItemSettingModule, ShopItemSettingModuleType } from '../../models/shop-item/shop-item-setting-module.model';
import { ShopItemHelperService } from '../../services/helpers/shop-item-helper.service';
import { downloadSessionAttendancePdf } from 'src/app/pages/admin/org-admin/components/modals/session-card-modal/session-card-modal.component';
import { PdfService } from '../../services/pdf.service';
import { SessionAttendancesService } from '../../services/entities/session-attendances/session-attendances.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationStoreService } from '../../services/store/organization-store.service';
import { DeviceSize, SystemService } from '../../services/system.service';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { ExportService } from '../../services/BE/export.service';




@Component({
  selector: 'app-session-attendance-modal',
  standalone: true,
  imports: [
    CommonModule, TranslateModule,
    ButtonModule, ProgressSpinnerModule, MenuModule,
    ModalHeaderComponent, SessionAttendanceComponent, LocalizedDatePipe, LocationNamePipe,
    ModalFooterMenuComponent
  ],
  templateUrl: './session-attendance-modal.component.html',
  styleUrls: ['./session-attendance-modal.component.scss']
})
export class SessionAttendanceModalComponent extends Modal implements OnInit, OnDestroy, AfterViewInit {
  SessionFormat = SessionFormat;

  @Input() sessionUuid: string | undefined;

  @ViewChild('sessionAttendanceEl') sessionAttendanceComponent: SessionAttendanceComponent | undefined;
  @ViewChild('downloadModal') downloadModal: TemplateRef<any> | undefined;

  footerMenuItems: IModalFooterMenuItem[] = [];
  shopItemSettingModules: IShopItemSettingModule[] = [];
  fetchingShopItemSettingModules: boolean = false;
  _downloadingSessionAttendancePdf: boolean = false;
  get downloadingSessionAttendancePdf(): boolean { return this._downloadingSessionAttendancePdf; }
  set downloadingSessionAttendancePdf(value: boolean) {
    this._downloadingSessionAttendancePdf = value;
    this.initDownloadMenuItems();
  }
  _downloadingSessionAttendanceSheet: boolean = false;
  get downloadingSessionAttendanceSheet(): boolean { return this._downloadingSessionAttendanceSheet; }
  set downloadingSessionAttendanceSheet(value: boolean) {
    this._downloadingSessionAttendanceSheet = value;
    this.initDownloadMenuItems();
  }
  downloadMenuItems: MenuItem[] = [];
  downloadModalRef: NgbModalRef | undefined;

  subs: Subscription[] = [];
  
  constructor(
    private modalService: ModalService,
    private shopItemsService: ShopItemsService,
    private siHelper: ShopItemHelperService,
    private pdfService: PdfService,
    private sessionAttendanceService: SessionAttendancesService,
    private translate: TranslateService,
    private localizedDatePipe: LocalizedDatePipe,
    private cdr: ChangeDetectorRef,
    private modal: NgbModal,
    private orgStore: OrganizationStoreService,
    private sysService: SystemService,
    private exportService: ExportService,
  ) {
    super();
  }


  override ngOnInit(): void {
    super.ngOnInit();

    this.initFooterMenuItems();

  }

  ngAfterViewInit(): void {

    this.sessionAttendanceComponent?.sessionAttendance$.pipe(
      filter(sessionAttendance => !!sessionAttendance),
      take(1)
    ).subscribe(sessionAttendance => {
      const sa = sessionAttendance!;

      this.fetchingShopItemSettingModules = true;
      this.shopItemsService.getSiSettingModulesByType({
        shopItemId: sa.shopItem.id,
        type: ShopItemSettingModuleType.ATTENDANCE
      }).pipe(
        take(1)
      ).subscribe({
        next: (modules) => {
          this.fetchingShopItemSettingModules = false;
          this.shopItemSettingModules = modules;
          this.initFooterMenuItems();
        },
        error: (err) => {
          this.fetchingShopItemSettingModules = false;
          console.error('Error fetching shop item setting modules:', err);
        }
      })
    })

  }

  onFindCustomer() {
    const res = this.modalService.openFindCustomerModal(FindCustomerModalComponent);
    res.pipe(
      first()
    ).subscribe(customer => {
      if (customer) {
        this.modalService.openLecturerCustomerCardModal({
          c: LecturerCustomerCardModalComponent,
          userId: customer.id,
          activeTab: LecturerCustomerCardTab.ATTENDANCE,
        })
      }
    })
  }

  private initFooterMenuItems() {
    const items: IModalFooterMenuItem[] = [];

    items.push({
      icon: 'pi pi-chevron-left',
      translationText: 'shared.footer-menu.item.close.label',
      action: () => {
        this.close();
      }
    }, {
      icon: 'pi pi-search',
      translationText: 'admin.session-attendance-modal.findattendee',
      action: () => {
        this.onFindCustomer();
      }
    });

    if (this.siHelper.getIsAttendanceModuleEnabled(this.shopItemSettingModules) || this.orgStore.isSessionAttendanceDownloadSheetEnabled()) {
      items.push({
        icon: 'pi pi-download',
        translationText: 'admin.session-attendance-modal.download',
        isDisabled: () => this.sessionAttendanceComponent?.fetching ?? false,
        action: () => {
          this.initDownloadMenuItems();
          this.downloadModalRef = this.modal.open(this.downloadModal, {
            size: 'md',
            windowClass: this.sysService.deviceSize$.getValue() === DeviceSize.SM ? 'modal-down' : '',
          })
        }
      })
    }

    

    items.push({
      icon: 'pi pi-check',
      translationText: 'shared.footer-menu.item.done.label',
      action: () => {
        this.close();
      },
    });

    this.footerMenuItems = items;
  }

  private initDownloadMenuItems() {
    const menuItems: MenuItem[] = [];

    menuItems.push({
      label: this.translate.instant('admin.session-attendance-modal.download.attendance-pdf'),
      disabled: !this.siHelper.getIsAttendanceModuleEnabled(this.shopItemSettingModules),
      icon: this.downloadingSessionAttendancePdf ? 'pi pi-spin pi-spinner' : undefined,
      command: () => {
        const sa = this.sessionAttendanceComponent?.sessionAttendance$.value;
        if (!sa) return;
        this.downloadingSessionAttendancePdf = true;
        downloadSessionAttendancePdf(
          this.pdfService,
          this.sessionAttendanceService,
          sa.session.id,
          {
            sessionIndex: sa.session.index,
            shopItemTitle: sa.shopItem.title,
            startAt: sa.session.startAt
          },
          this.translate,
          this.localizedDatePipe,
        ).subscribe({
          next: () => {
            this.downloadingSessionAttendancePdf = false;
            this.downloadModalRef?.close();
          },
          error: (err) => {
            this.downloadingSessionAttendancePdf = false;
            console.error('Error downloading session attendance PDF:', err);
          }
        });
      }
    }, {
      label: this.translate.instant('admin.session-attendance-modal.download.attendance-sheet'),
      disabled: !this.orgStore.isSessionAttendanceDownloadSheetEnabled(),
      icon: this.downloadingSessionAttendanceSheet ? 'pi pi-spin pi-spinner' : undefined,
      command: () => {
        const sa = this.sessionAttendanceComponent?.sessionAttendance$.value;
        if (!sa) return;
        this.downloadingSessionAttendanceSheet = true;
        this.exportService.getSessionAttendanceSheet({
          sessionId: sa.session.id
        }).pipe(
          take(1)
        ).subscribe({
          next: (res) => {
            this.downloadingSessionAttendanceSheet = false;
            this.downloadModalRef?.close();
            this.pdfService.downloadBase64SheetFile(res, 'asd.xlsx');
          },
          error: (err) => {
            this.downloadingSessionAttendanceSheet = false;
            console.error('Error downloading session attendance sheet:', err);
          }
        })
      },
    })

    this.downloadMenuItems = menuItems;
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();

    this.subs.forEach(sub => sub.unsubscribe());
  }
}

  // @if (siHelper.getIsAttendanceModuleEnabled(sessionCardData?.shopItem?.settingModules ?? null)) {
  //   <button
  //     [loading]="preparingAttendancePdfDownload"
  //     (click)="onDownloadAttendancePdf()"
  //     pButton
  //     icon="pi pi-download"
  //     label="{{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.download-attendance-document-btn.label' | translate }}"
  //     class="p-button-sm">
  //   </button>
  // }